import { useEffect, useState } from "preact/hooks";

export type ScrollProgressProps = {
  /** The element the page is read down to: 100 % is when its top reaches the bottom of the window. */
  targetSelector: string;
  visible: boolean;
};

const progressOf = (targetSelector: string): number | null => {
  const target = document.querySelector(targetSelector);
  if (!target) {
    return null;
  }
  const maxScroll = target.getBoundingClientRect().top + window.scrollY - window.innerHeight;
  return Math.min(Math.max((window.scrollY / maxScroll) * 100, 0), 100);
};

/** How far down the article the visitor has read. */
export const ScrollProgress = ({ targetSelector, visible }: ScrollProgressProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const value = progressOf(targetSelector);
      if (value === null) {
        return;
      }
      setProgress(value);
    };
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, [targetSelector]);

  if (!visible) {
    return null;
  }

  return (
    <div class="fixed top-0 left-0 right-0 z-[1001] flex justify-center">
      <div class="max-w-lg w-full">
        <div data-testid="scroll-progress" class="h-1 bg-blue-600 dark:bg-blue-400" style={{ width: `${progress}%`, transitionProperty: "none" }} />
      </div>
    </div>
  );
};
